<div class="wrapper">
  @if (variant === 'primary') {
    <h1>{{ title }}</h1>
  }
  @if (variant === 'secondary') {
    <h2>{{ title }}</h2>
  }

  <div class="actions">
    <ng-content></ng-content>
  </div>
</div>